/* Pooja Ragenee theme · pr-bag.js: Shopify AJAX cart (cart/add.js, cart.js, cart/change.js) + the bag drawer (snippets/pr-bag.liquid).
   PR.bag.add({ id, quantity, properties } | [..]) -> Promise<cart>; change(key, qty); refresh(); open(); close(); count. Emits pr:cart { cart }.
   The drawer's checkout <form action="/cart"> with name="checkout" is never re-rendered (Kwik COD hooks it). */
(function (w, d) {
  'use strict';
  var PR = w.PR, $ = PR.$, $$ = PR.$$, esc = PR.esc;
  var bag, scrim, lastFocus;
  function R() { return PR.cfg.routes; }
  function req(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || PR.t('bag.error') || 'Something went wrong.'); e.status = r.status; e.data = j; throw e; }
        return j;
      });
    });
  }
  function badges(n) {
    $$('[data-ap-bag-count]').forEach(function (el) { el.textContent = n > 9 ? '9+' : String(n); el.hidden = !n; });
    $$('[data-ap-bag-btn]').forEach(function (b) { b.setAttribute('aria-label', n ? PR.t('bag.label', { count: n }) : PR.t('bag.title') || 'Bag'); });
  }
  function bump() { $$('[data-ap-bag-count]').forEach(function (el) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }); }
  function pick(it) {
    var col = [], rest = [];
    (it.options_with_values || []).forEach(function (o) {
      if (/^colou?r$/i.test(o.name)) col.push(PR.colour.label(o.value));
      else if (o.value !== 'Default Title') rest.push(/^size$/i.test(o.name) ? PR.size.norm(o.value) : o.value);
    });
    return col.concat(rest).join(' · ');
  }
  function line(it) {
    var name = PR.name(it.handle, it.product_title), cat = ((w.PR_DATA || {}).cats || {})[it.handle] || 'bra';
    var img = it.image ? it.image + (it.image.indexOf('?') >= 0 ? '&' : '?') + 'width=160' : '';
    var struck = it.original_line_price > it.final_line_price ? '<s>' + PR.money(it.original_line_price) + '</s>' : '';
    return '<li class="ap-line" data-key="' + esc(it.key) + '">' +
      '<a class="ap-line__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true"><div class="ap-media" data-cat="' + esc(cat) + '">' +
        (img ? '<img class="ap-media__img" src="' + esc(img) + '" alt="" width="160" height="200" loading="lazy" decoding="async">' : '') + '</div></a>' +
      '<div class="ap-line__main"><div class="ap-line__top"><p class="ap-line__name"><a href="' + esc(it.url) + '">' + esc(name) + '</a></p>' +
        '<span class="ap-line__price">' + PR.money(it.final_line_price) + struck + '</span></div>' +
        '<p class="ap-line__pick">' + esc(pick(it)) + (it.quantity > 1 ? ' · ' + esc(PR.t('product.each', { price: PR.money(it.final_price) })) : '') + '</p>' +
        '<div class="ap-line__foot"><div class="ap-qty ap-qty--sm" role="group" aria-label="' + esc(PR.t('bag.quantity_of', { name: name })) + '">' +
          '<button type="button" data-pr-qty="-1" aria-label="' + esc(PR.t('bag.decrease')) + '">−</button><output aria-live="polite">' + it.quantity + '</output>' +
          '<button type="button" data-pr-qty="1" aria-label="' + esc(PR.t('bag.increase')) + '">+</button></div>' +
          '<button type="button" class="ap-line__remove" data-pr-remove>' + esc(PR.t('bag.remove')) + '</button></div></div></li>';
  }
  function render(c) {
    var n = c.item_count || 0;
    PR.bag.count = n; PR.bag.cart = c; badges(n);
    if (!bag) return;
    $('[data-pr-bag-n]', bag).textContent = n ? PR.t('bag.items', { count: n }) : '';
    var body = $('[data-pr-bag-body]', bag), foot = $('[data-pr-bag-foot]', bag);
    var err = $('[data-pr-bag-err]', bag); if (err) err.hidden = true;
    if (!n) {
      var tpl = $('template[data-pr-bag-empty]', bag);   /* Liquid pills: Shop bras / Shop panties, Shop all as fallback */
      var pills = tpl && tpl.innerHTML.trim() ? tpl.innerHTML : '<div class="ap-pills"><a class="ap-pill" href="' + esc(R().all) + '">' + esc(PR.t('general.shop_all')) + '</a></div>';
      body.innerHTML = '<div class="ap-bag__empty"><p class="ap-bag__empty-t">' + esc(PR.t('bag.empty')) + '</p>' + pills + (PR.cfg.copy.freeShip ? '<p class="ap-bag__empty-n">' + esc(PR.cfg.copy.freeShip) + '</p>' : '') + '</div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = '<ul class="ap-lines" role="list">' + c.items.map(line).join('') + '</ul>';
    var sub = c.total_price, from = PR.cfg.freeShipFrom, left = Math.max(0, from - sub), ship = left ? PR.cfg.shipFee : 0;
    $('[data-pr-bag-hint]', bag).innerHTML = '<p class="ap-bag__hint">' + (left ? PR.t('bag.free_ship_left_html', { amount: PR.money(left) }) : '<b>' + esc(PR.t('bag.free_ship_done')) + '</b>') +
      '<span class="ap-bag__bar" aria-hidden="true"><i style="--fill:' + Math.min(1, sub / from).toFixed(3) + '"></i></span></p>';
    $('[data-pr-bag-sum]', bag).innerHTML = '<dt>' + esc(PR.t('bag.subtotal')) + '</dt><dd>' + PR.money(sub) + '</dd><dt>' + esc(PR.t('bag.shipping')) + '</dt><dd>' +
      (ship ? PR.money(ship) : esc(PR.t('bag.free'))) + '</dd><dt class="ap-bag__total">' + esc(PR.t('bag.total')) + '</dt><dd class="ap-bag__total">' + PR.money(sub + ship) + '</dd>';
    var fine = $('[data-pr-bag-fine]', bag); if (fine) fine.textContent = PR.cfg.copy.payments || '';
    PR.images.scan(body);
  }
  function done(c) { render(c); PR.emit('cart', { cart: c }); return c; }
  function fail(e) { var m = (e && e.message) || PR.t('bag.error'); PR.toast(m); var err = bag && $('[data-pr-bag-err]', bag); if (err && bag.classList.contains('is-open')) { err.textContent = m; err.hidden = false; } throw e; }
  function toggle(on) {
    if (!bag) return;
    if (on) { lastFocus = d.activeElement; PR.closeChrome(); }
    bag.classList.toggle('is-open', on); bag.inert = !on; if (scrim) scrim.classList.toggle('is-open', on);
    d.body.classList.toggle('ap-lock', on);
    if (on) setTimeout(function () { var h = $('#ap-bag-title', bag); if (h) h.focus({ preventScroll: true }); }, 50);
    else if (lastFocus && lastFocus.focus && d.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  PR.bag = {
    count: 0, cart: null,
    add: function (items) {
      var list = (Array.isArray(items) ? items : [items]).map(function (x) { var o = { id: +x.id, quantity: Math.max(1, +x.quantity || 1) }; if (x.properties) o.properties = x.properties; return o; });
      return req(R().cartAdd, { items: list }).then(function () { return req(R().cartJs); }).then(function (c) { done(c); bump(); PR.bag.open(false); return c; }, fail);
    },
    change: function (key, qty) {
      if (bag) bag.classList.add('is-busy');
      return req(R().cartChange, { id: key, quantity: Math.max(0, +qty || 0) }).then(done, function (e) { PR.bag.refresh().catch(function () {}); return fail(e); })
        .then(function (c) { if (bag) bag.classList.remove('is-busy'); return c; }, function (e) { if (bag) bag.classList.remove('is-busy'); throw e; });
    },
    refresh: function () { return req(R().cartJs).then(done); },
    open: function (fetchFirst) { toggle(true); if (fetchFirst !== false) PR.bag.refresh().catch(function () {}); },
    close: function () { if (bag && bag.classList.contains('is-open')) toggle(false); }
  };
  PR.ready(function () {
    bag = $('[data-pr-bag]'); scrim = $('[data-pr-bag-scrim]');
    var c0 = $('[data-ap-bag-count]'); PR.bag.count = c0 && !c0.hidden ? parseInt(c0.textContent, 10) || 0 : 0;
    d.addEventListener('click', function (e) { var b = e.target.closest('[data-ap-bag-btn]'); if (b) { e.preventDefault(); PR.bag.open(); } });
    if (!bag) return;
    if (scrim) scrim.addEventListener('click', function () { PR.bag.close(); });
    bag.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t) return;
      if (t.hasAttribute('data-pr-bag-close')) { PR.bag.close(); return; }
      var li = t.closest('.ap-line'); if (!li) return;
      var key = li.getAttribute('data-key'), q = parseInt(($('output', li) || {}).textContent, 10) || 1;
      if (t.hasAttribute('data-pr-qty')) {
        var dir = +t.getAttribute('data-pr-qty');
        PR.bag.change(key, q + dir).then(function () {
          var nl = $('.ap-line[data-key="' + key + '"] [data-pr-qty="' + dir + '"]', bag) || $('[data-pr-bag-close]', bag); if (nl) nl.focus();
        }).catch(function () {});
      } else if (t.hasAttribute('data-pr-remove')) {
        PR.bag.change(key, 0).then(function () { var nx = $('[data-pr-remove]', bag) || $('.ap-pill', bag) || $('[data-pr-bag-close]', bag); if (nx) nx.focus(); }).catch(function () {});
      }
    });
    bag.addEventListener('keydown', function (e) { if (e.key === 'Escape') PR.bag.close(); if (e.key === 'Tab' && PR.trapTab) PR.trapTab(e, bag); });
    w.addEventListener('pageshow', function (e) { if (e.persisted) PR.bag.refresh().catch(function () {}); });
  });
})(window, document);